
































































import {EventBus} from '@/plugins/event-bus';
import Steepers from "@/components/Steepers.vue"
import {Component, Vue} from 'vue-property-decorator'
import {State} from 'vuex-class'
import {UserDetailInterface, UserInterface} from "@/models/User";
import {ClaseEnum, ClasesAlumnosInterface} from '@/models/Clases';

@Component({
    components: {Steepers}
})
export default class PerformActivity extends Vue{
    public activityNumber = 1;
    @State(state => state.activity.activity) activity: any;
    @State(state => state.user.userDetails) userDetails: UserDetailInterface;
    @State(state => state.auth.user) user: any;
    @State(state => state.auth.fullUser) fullUser: UserInterface;

    public validate = false;
    public cancel = false;

    async BindClasesActivity(){
        await this.$store.dispatch('bindActivity', {id: this.$route.params.id, order: 'asc'} )
    }
    click(id: string) {
        EventBus.$emit('validate-steep-custom', id);
    }

    cancelar(){
        const data: ClasesAlumnosInterface = {
            clase: (parseInt(this.$route.params.index) + 1),
            status: ClaseEnum.error,
            user:{
                id: this.user.id,
                role:this.fullUser.role,
                email:this.user.email,
                category: this.user.category,
                lastName: this.fullUser.lastName,
                firstName: this.fullUser.firstName
            }
        };
        this.$store.dispatch('createdHistoryClass', data);

        this.$router.push('/myclass')
    }

    reiniciar(){
        EventBus.$off('validate-response');
        this.validate = false;
        this.cancel = false;
        this.activityNumber = this.activityNumber > 1 ? this.activityNumber - 1 : 1;
        this.readEvents();
    }
    calificate(){
        const Index: number = (parseInt(this.$route.params.index) + 1);
        if (this.userDetails.lastClass === Index){

            this.$store.dispatch('updateClassUser', {
                data: {
                    lastClass: (this.userDetails.lastClass + 1)
                },
                path: this.user.id
            })
        }
        this.$router.push('/myClass')
    }

    nextSteep(index: number){
        if ((index + 1) === this.activity.length){
            const data: ClasesAlumnosInterface = {
                clase: (parseInt(this.$route.params.index) + 1),
                status: ClaseEnum.finish,
                user:{
                    id: this.user.id,
                    role:this.fullUser.role,
                    email:this.user.email,
                    category: this.user.category,
                    lastName: this.fullUser.lastName,
                    firstName: this.fullUser.firstName
                }
            };
            this.$store.dispatch('createdHistoryClass', data);
           this.calificate()
        }else {
            this.activityNumber++;
            this.validate = false;
            this.cancel = false;
        }

    }

    mounted(){
        this.activityNumber =1
    }
    readEvents() {

        EventBus.$on('validate-response', (data: any) => {
            if (data.valid){
                this.validate = true
            }else {

                this.validate = false;
                this.cancel = true
            }
        });
    }

    created(){
        this.readEvents();


        this.BindClasesActivity()
    }
    destroyed() {
        EventBus.$off();
    }

}
